import _ from 'lodash'
import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/validation-messages'
import CONSTANTS from 'core/data-model/constants/messages'
import { isValidAge } from 'core/service/insured/birthdate'
import {
  getDisplayProducts,
  getSelectedDisplayProduct,
  getSelectedDisplayProductQuery,
} from 'quick-quote/product-selection/selectors'
import { renderUnit } from 'core/service/insured/age'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { selectBasicPlan, UPDATE_SELECTED_BASIC_PLAN, VALIDATE_BASIC_PLAN, validateBasicPlan } from './actions'
import {
  getAge,
  getAllNatureOfDutyCodes,
  getInsured,
  getPayerAge,
  getPayerGender,
} from 'quick-quote/insured-information/selectors'
import { getSelectedModelFactorID } from './selectors'
import { getAvailableRiders } from 'quick-quote/product-common/coverage-plan/selectors'
import { updateCoveragePlanState } from 'quick-quote/product-common/coverage-plan/sagas'
import { updateBasicPlanErrorMessage } from 'quick-quote/product-common/coverage-plan/actions'

export const onUpdateSelectedBasicPlan = function*(action) {
  const basicPlanCode = action.payload
  const displayProducts = yield select(getDisplayProducts)
  const product = _.find(displayProducts, { code: basicPlanCode })
  !!product && (yield put(selectBasicPlan(product)))
}

export const generateCoveragePlanFromBasicPlanChange = function*(calculateCoveragePlanFn) {
  const displayProductQuery = yield select(getSelectedDisplayProductQuery)
  const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
  const insured = yield select(getInsured)
  const modelFactorID = yield select(getSelectedModelFactorID)
  const availableRiders = yield select(getAvailableRiders)
  const payerAge = yield select(getPayerAge)
  const payerGender = yield select(getPayerGender)
  const newValue = yield call(calculateCoveragePlanFn, {
    displayProductQuery,
    insured,
    natureOfDutyCodes,
    modelFactorID,
    availableRiders,
    payerAge,
    payerGender,
  })
  yield call(updateCoveragePlanState, newValue)
  yield put(validateBasicPlan())
}

const getValidationMessage = (displayProduct, age) => {
  const { entryAge } = displayProduct
  if (!entryAge || isValidAge(age.value, age.unit, entryAge)) {
    return ''
  }
  return Mustache.render(MESSAGES.RULE_AGE, {
    owner: CONSTANTS.INSURED_PERSON,
    minimumAge: `${entryAge.minimum.value} ${renderUnit(entryAge.minimum.unit)}`,
    maximumAge: `${entryAge.maximum.value} ${renderUnit(entryAge.maximum.unit)}`,
  })
}

export const onValidateBasicPlan = function*() {
  const selectedDisplayProduct = yield select(getSelectedDisplayProduct)
  const age = yield select(getAge)
  const message = yield call(getValidationMessage, selectedDisplayProduct, age)
  return yield put(updateBasicPlanErrorMessage(message))
}

export function* sagas() {
  yield [
    takeLatest(UPDATE_SELECTED_BASIC_PLAN, onUpdateSelectedBasicPlan),
    // saga impact current product remove take latest for now
    //takeLatest(SELECT_BASIC_PLAN, generateCoveragePlanFromBasicPlanChange, calculateCoveragePlanFromBasicPlanChange),
    takeLatest(VALIDATE_BASIC_PLAN, onValidateBasicPlan),
  ]
}
